export default __webpack_public_path__ + "static/media/exclamation.8a11848c.svg";